import { Input, Select } from '@trackman/web-shared-components';
import { LocationType } from 'types/admin/trackmanEventsAdmin';

export const LocationSettings = ({
  locationType,
  setLocationType,
  location,
  setLocation,
}: {
  locationType: LocationType;
  setLocationType: (locationType: LocationType) => void;
  location: string;
  setLocation: (location: string) => void;
}) => {
  const locationOptions = [
    { label: 'In person', value: 'InPerson' },
    { label: 'Online', value: 'Online' },
  ];

  return (
    <div className='admin-edit-section'>
      <h2>Location*</h2>
      <div className='inputs-container event-location-settings'>
        <Select
          label=''
          value={locationType}
          className='narrow-select'
          required
          onChange={(event) => {
            setLocationType(event.target.value as LocationType);

            if (event.target.value === 'Online') {
              setLocation('');
            }
          }}
          selectOptions={locationOptions.map((location) => {
            return {
              label: location.label,
              value: location.value,
            };
          })}
        />
        <Input
          label='City name'
          value={location}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLocation(e.currentTarget.value)}
          disabled={locationType === 'Online'}
        />
      </div>
    </div>
  );
};
